import React from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import CouponPerformancePanel from "./TablesAndGraphs/ByFilter/CouponPerformancePanel.jsx";
import DiscountPerformanceTable from "./TablesAndGraphs/ByFilter/DiscountPerformanceTable.jsx";


export default function DiscountAndCouponOverview({project}) {

    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout
        title={t('route.sales-promotions')}
    >
        <CouponPerformancePanel project={project}/>
        <DiscountPerformanceTable project={project}/>
    </OrderDashboardLayout>;
}
